import { useContext } from 'react';

import config from '@/config';
import ProfileDataContext from '@/context/ProfileDataContext';
import useCache from '@/hooks/useCache';

import ProfileArtists from '../artists';
import ProfileArtlists from '../artlists';
import ProfileArtworks from '../artworks';
import ProfileBoard from '../board';
import ProfileCollection from '../collection';
import ProfileCommunity from '../community';

export default function ProfileRedirect() {
  const { profileData } = useContext(ProfileDataContext);
  const fetchUrl = `${config.apis.api.url}/user/userProfile/${profileData._id}`;

  const query = { user_type: profileData.user_type };

  const { fetchData: userProfileInfo, loading } = useCache(`${profileData._id}_userProfileInfo`, fetchUrl, { includeSearchQueries: query });
  const isGallery = profileData.user_type === "gallery";
  const isArtist = profileData.user_type === "artist";

  if(loading) {
    return <></>;
  }
  if(isGallery || isArtist) {
    if (isGallery) {
      if (userProfileInfo && userProfileInfo.data.artworks)  return  <ProfileArtworks/> ;
      else if (userProfileInfo && userProfileInfo.data.posts) return <ProfileBoard/> ;
      else if (userProfileInfo && userProfileInfo.data.artlists) return <ProfileArtlists/>;
      else if (userProfileInfo && userProfileInfo.data.artists) return <ProfileArtists/>;
    } else if (isArtist) {
      if (userProfileInfo && userProfileInfo.data.artworks) return <ProfileArtworks/>;
      else if (userProfileInfo && userProfileInfo.data.collections) return  <ProfileCollection/>;
      else if (userProfileInfo && (userProfileInfo.data.thoughts || userProfileInfo.data.ratings)) return <ProfileCommunity/>;
      else if (userProfileInfo && userProfileInfo.data.artlists) return <ProfileArtlists/>;
    }
  } else {
    if (userProfileInfo && userProfileInfo.data.collections) return <ProfileCollection/>;
    else if (userProfileInfo && (userProfileInfo.data.thoughts || userProfileInfo.data.ratings)) return <ProfileCommunity/>;
    else if (userProfileInfo && userProfileInfo.data.artlists) return <ProfileArtlists />;
  }
}
